import React, { useEffect, useMemo, useState } from 'react'
import { Modal, Text, Flex, Box, Button, Skeleton , Link,Image, useMatchBreakpoints} from '@pancakeswap/uikit'
import useTheme from 'hooks/useTheme'
import { useTranslation } from 'contexts/Localization'
import Balance from 'components/Balance'
import { createClient } from '@supabase/supabase-js';
import styled from 'styled-components'
import { ButtonPro, ButtonText, Container, HeadingText, ImageWrapper, SalesSectionProps, ScrollBox, SubHeadingText, Word } from './Styled'

const CustomText = styled(Text)`
  color: #fff;  // Applying the hex color directly
  font-size: 16px;
      font-weight: bold;
  margin-right: 5px;
`;
 

const SalesSection: React.FC<SalesSectionProps> = (props) => {
  const { t } = useTranslation()
  const { headingText, bodyText, reverse, primaryButton, secondaryButton, images } = props
  const headingTranslatedText = t(headingText)
  const bodyTranslatedText = t(bodyText) 
  const { theme } = useTheme()
  const [allin2, setAllin2] = useState(null);
  const [lastUpdated, setLastUpdated] = useState(null);

                // BE2MINING  + POOLOK + FARMOK + LOCKED
  const { isXs, isSm, isMd, isLg, isXl } = useMatchBreakpoints()
  const isMobile = !isXs
  const isMobile2 = !isSm
  const isMobile3 = !isMd
  const isMobile4 = !isLg
  const isMobile5 = !isXl
 // Egyedi azonosító generálása minden szóhoz
 const generateUniqueKey = (word: string, index: number) => `${word}-${index}`;

 // A fő komponens, amely a szöveget és az alfejléc szöveget megjeleníti
 const Component = ({ headingTranslatedText, bodyTranslatedText }) => (
   <>
     <HeadingText>
       {headingTranslatedText.split(' ').map((word, index) => {
         // Kiemeljük az 1., 10., 11., és 12. szavakat
         const isHighlighted = [0, 9, 10, 11].includes(index);
         return (
           <Word key={generateUniqueKey(word, index)} isHighlighted={isHighlighted}>
             {word}
           </Word>
         );
       })}
     </HeadingText>
     <SubHeadingText>{bodyTranslatedText}</SubHeadingText>
   </>
 );
 
  return (
    <Container>
    <Flex flexDirection="column" mt='25px'  mb='30px'>
      <Flex
        flexDirection={['column-reverse', null, null, reverse ? 'row-reverse' : 'row']}
        alignItems={['flex-end', null, null, 'center']}
        justifyContent="center"
      > 
                 <Flex
          height={['230px', null, null, '100%']}
          width={['230px', null, null, '100%']}
          flex={[null, null, null, '1']}
          mb={['0px', null, null, '0']}   
        >
{!isMobile &&  <ImageWrapper><img src="/images/pixel/G3.png" alt="ifo bunny" width="450px" height="450px"/> </ImageWrapper>}
{!isMobile2 &&   <ImageWrapper><img src="/images/pixel/G1.png" alt="ifo bunny" width="450px" height="450px"/> </ImageWrapper>}
{!isMobile3 &&   <ImageWrapper><img src="/images/pixel/G1.png" alt="ifo bunny" width="450px" height="450px"/> </ImageWrapper>}
{!isMobile4 &&  <ImageWrapper><img src="/images/pixel/G3.png" alt="ifo bunny" width="450px" height="450px"/> </ImageWrapper>}
{!isMobile5 &&   <ImageWrapper><img src="/images/pixel/G3.png" alt="ifo bunny" width="450px" height="450px"/> </ImageWrapper>}
         </Flex>
        <Flex
          flexDirection="column"
          flex="1" 
          ml={[null, null, null, reverse && '64px']} 
          mr={[null, null, null, !reverse && '64px']}
          alignSelf={['flex-start', null, null, 'center']}
        >  
            <Component headingTranslatedText={headingTranslatedText} bodyTranslatedText={bodyTranslatedText} />

                 <Flex mb='10px'>
            <Link mr="16px" external={primaryButton.external} href="/swap">
              <ButtonPro  variant="secondary" height="40px" mb="16px" width="100px">
              <ButtonText color="text" bold fontSize="16px">
          {t('TRADE')}
        </ButtonText>
              </ButtonPro>
            </Link>
            <Link  mr="16px"  external={secondaryButton.external} href="/pools/all">
            <ButtonPro variant="gold" height="40px" mb="16px" width="120px">
              <ButtonText color="gold" bold fontSize="16px">
          {t('EARN')}
        </ButtonText>
              </ButtonPro>
            </Link> 
          </Flex>
          <ScrollBox>
          <Flex justifyContent="center" alignItems="center">
          <Flex flexDirection="column" alignItems="center" >
      <ImageWrapper>
        <img src="/images/wallet/000.png" alt="ifo bunny" width="40px" height="40px"/>
      </ImageWrapper>
      </Flex >
      <Flex flexDirection="column" alignItems="center" >
      <ImageWrapper>
        <img src="/images/wallet/0274.png" alt="ifo bunny" width="38px" height="38px"/>
      </ImageWrapper>
      </Flex >
          <Flex flexDirection="column" alignItems="left" >
          <CustomText>
  {t('NEW')}
</CustomText>
     
    </Flex >
    </Flex>
    </ScrollBox>
        </Flex>
      </Flex>
    </Flex>
          </Container>
  )
}
export default SalesSection


